import Headroom from 'headroom.js';

class ScrollHeader {
  constructor(options = {}) {
    this.config = {
      module: document.querySelector('[data-module="Header"]'),
      ...options
    };
  }

  init() {
    if (!this.config.module) {
      return;
    }

    const headroom = new Headroom(this.config.module, {
      offset: 100,
      tolerance: 5
    });

    headroom.init();
  }
}

export default ScrollHeader;
